import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-data-upload",
  "use": "icon-data-upload-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-data-upload\"><defs><style type=\"text/css\"></style></defs><path d=\"M532.48 314.88c-5.12-5.12-12.8-7.68-20.48-7.68-7.68 0-15.36 2.56-20.48 7.68l-125.44 153.6c-10.24 10.24-10.24 25.6 0 35.84 10.24 10.24 25.6 10.24 35.84 0l84.48-102.4V793.6c0 15.36 10.24 25.6 25.6 25.6s25.6-10.24 25.6-25.6V401.92l84.48 102.4c10.24 10.24 25.6 10.24 35.84 0 10.24-10.24 10.24-25.6 0-35.84l-125.44-153.6zM742.4 204.8H281.6c-15.36 0-25.6 10.24-25.6 25.6s10.24 25.6 25.6 25.6h460.8c15.36 0 25.6-10.24 25.6-25.6 0-12.8-10.24-25.6-25.6-25.6z m76.8-102.4H204.8C148.48 102.4 102.4 148.48 102.4 204.8v614.4c0 56.32 46.08 102.4 102.4 102.4h614.4c56.32 0 102.4-46.08 102.4-102.4V204.8c0-56.32-46.08-102.4-102.4-102.4z m51.2 716.8c0 28.16-23.04 51.2-51.2 51.2H204.8c-28.16 0-51.2-23.04-51.2-51.2V204.8c0-28.16 23.04-51.2 51.2-51.2h614.4c28.16 0 51.2 23.04 51.2 51.2v614.4z\" p-id=\"15844\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/data-upload.svg
// module id = u/Xj
// module chunks = 102